var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 664,
    viewBox: "0 0 750 664",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.266 152.853L223.25 179.385L114.635 116.372L162.309 89.8398L269.266 152.853Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.266 292.975L223.25 319.507L114.635 256.494L162.309 229.962L269.266 292.975Z",
    stroke: "#231F20",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.004 292.975L222.988 319.507L114.373 256.494L162.047 229.962L269.004 292.975Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.249 179.387V319.508",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.724 89.8398V229.961L114.681 256.447V116.326",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M269.266 152.394V292.515",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.663 204.627L131.647 231.159L23.0322 168.146L70.7066 141.614L177.663 204.627Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.663 344.748L131.647 371.28L23.0322 308.267L70.7066 281.735L177.663 344.748Z",
    stroke: "#231F20",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.402 344.748L131.386 371.28L22.7715 308.267L70.4459 281.735L177.402 344.748Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.649 231.159V371.28",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.122 141.614V281.736L23.0791 308.221V168.1",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.664 204.167V344.288",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M562.66 222.914L516.644 249.446L408.029 186.433L455.704 159.901L562.66 222.914Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M562.66 363.036L516.644 389.567L408.029 326.554L455.704 300.022L562.66 363.036Z",
    stroke: "#231F20",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M562.399 363.036L516.382 389.567L407.768 326.554L455.442 300.022L562.399 363.036Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M516.645 249.446V389.568",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M456.118 159.901V300.023L408.075 326.508V186.387",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M562.66 222.455V362.576",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.252 301.972L659.236 328.504L550.621 265.491L598.296 238.959L705.252 301.972Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.252 442.093L659.236 468.625L550.621 405.612L598.296 379.08L705.252 442.093Z",
    stroke: "#231F20",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.99 442.093L658.974 468.625L550.359 405.612L598.034 379.08L704.99 442.093Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.236 328.504V468.625",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.709 238.959V379.08L550.666 405.566V265.445",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.252 301.512V441.633",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M306.68 128.147L352.696 154.679L461.311 91.6656L413.636 65.1338L306.68 128.147Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M306.68 268.269L352.696 294.801L461.311 231.788L413.636 205.256L306.68 268.269Z",
    stroke: "#231F20",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M306.941 268.269L352.958 294.801L461.572 231.788L413.898 205.256L306.941 268.269Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M352.696 154.68V294.801",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M413.223 65.1338V205.255L461.266 231.741V91.6196",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M306.68 127.688V267.809",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.41 65.0131L251.426 91.545L360.041 28.5318L312.367 2L205.41 65.0131Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41 205.134L251.426 231.666L360.041 168.653L312.367 142.121L205.41 205.134Z",
    stroke: "#231F20",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.671 205.134L251.687 231.666L360.302 168.653L312.627 142.121L205.671 205.134Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.427 91.5449V231.666",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.953 2V142.121L359.996 168.607V28.4858",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.41 64.5527V204.674",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.595 495.406L359.611 521.938L468.226 458.924L420.551 432.393L313.595 495.406Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.595 635.527L359.611 662.059L468.226 599.046L420.551 572.514L313.595 635.527Z",
    stroke: "#231F20",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.855 635.527L359.872 662.059L468.486 599.046L420.812 572.514L313.855 635.527Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.612 521.938V662.059",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.138 432.393V572.514L468.181 599V458.878",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.595 494.945V635.067",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.249 432.562L269.265 459.094L377.88 396.081L330.206 369.549L223.249 432.562Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M223.249 572.683L269.265 599.215L377.88 536.202L330.206 509.67L223.249 572.683Z",
    stroke: "#231F20",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M223.512 572.683L269.528 599.215L378.143 536.202L330.468 509.67L223.512 572.683Z",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M269.266 459.093V599.214",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M329.791 369.549V509.67L377.834 536.156V396.035",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M223.249 432.101V572.222",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8418 146.852L732.143 541.653",
    stroke: "white",
    strokeWidth: 17.2923,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.702 495.057L496.463 579.375L151.284 379.119L302.794 294.801L642.702 495.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 464.277L162.51 379.959",
    stroke: "white",
    strokeWidth: 17.2923,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1047 431.632L11 463.209L43.5876 474.072",
    stroke: "white",
    strokeWidth: 17.2923,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.902 552.713L739 544.408L730.797 511.052",
    stroke: "white",
    strokeWidth: 17.2923,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5566 130.537L53.3193 144.136L67.0304 175.631",
    stroke: "white",
    strokeWidth: 17.2923,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M560.94 411.598L363.357 527.718",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10,
    strokeDasharray: "5.96 5.96"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M432.098 340.353L369.982 376.858",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10,
    strokeDasharray: "5.96 5.96"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M495.937 447.864L244.03 307.006",
    stroke: "white",
    strokeWidth: 2.16154,
    strokeMiterlimit: 10,
    strokeDasharray: "5.96 5.96"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.f14215d11904ed8f1a9e71c7bb45c39e.svg";
export { ForwardRef as ReactComponent };